module.exports = __webpack_public_path__ + "static/author2-498fdbd8981862e14caaf10c3273d65b.png";